<template>
  <div class="pagination-container">
    <ul class="pagination">
      <li class="page-item">
        <a class="page-link" v-on:click.prevent="prev">«</a>
      </li>
      <li
        v-if="internal.currentPage > 3"
        class="page-item"
      >
        <a class="page-link" v-on:click.prevent="setPage(1)">1</a>
      </li>
      <li
        v-if="internal.currentPage > 4"
        class="page-item disabled">
        <span class="page-link">...</span>
      </li>
      <li
        v-for="el in visiblePages"
        :key="el"
        :class="{ 'page-item': true, active: el === internal.currentPage }"
      >
        <a class="page-link" v-on:click.prevent="setPage(el)">{{ el }}</a>
      </li>
      <li
        v-if="internal.currentPage < internal.totalPages - 3"
        class="page-item disabled">
        <span class="page-link">...</span>
      </li>
      <li
        v-if="internal.currentPage < internal.totalPages - 2"
        class="page-item">
        <a class="page-link" v-on:click.prevent="setPage(internal.totalPages)">{{ internal.totalPages }}</a>
      </li>
      <li class="page-item">
        <a class="page-link" v-on:click.prevent="next">»</a>
      </li>
    </ul>
    <div style="display: flex; width: 100%; justify-content: center">
      <p style="margin-bottom: 0">{{ details }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "PaginationController",
  props: {
    pagination: {
      type: Object,
      default: 0,
    },
  },
  methods: {
    setPage: function (val) {
      this.internal.currentPage = val;
    },
    next: function () {
      if (this.internal.currentPage !== this.internal.totalPages) {
        this.internal.currentPage++;
      }
    },
    prev: function () {
      if (this.internal.currentPage > 1) {
        this.internal.currentPage--;
      }
    },
  },
  computed: {
    internal: {
      get() {
        return this.pagination;
      },
      set(val) {
        this.$emit("update:pagination", pagination);
      },
    },
    details: function () {
      let startItem =
        1 + (this.pagination.currentPage - 1) * this.pagination.pageSize;
      let endItem =
        (this.pagination.currentPage - 1) * this.pagination.pageSize +
        this.pagination.currentPageSize;
      let total = (this.pagination.totalPages - 1) * this.pagination.pageSize;
      let totalWord = parseInt(total / 10) * 10;

      return this.pagination.totalPages === this.pagination.currentPage
        ? ""
        : `${startItem} - ${endItem} of more than ${totalWord} listings`;
    },
    visiblePages() {
      let range = [];
      let start = Math.max(1, this.internal.currentPage - 2);
      let end = Math.min(this.internal.totalPages, this.internal.currentPage + 2);

      for (let i = start; i <= end; i++) {
        range.push(i);
      }

      return range;
    },
  },
};
</script>

<style lang="scss" scoped>
.pagination-container {
  margin-top: 30px;
  margin-bottom: calc(30px + 12px);
}

.pagination {
  justify-content: center;
  flex-wrap: wrap;
  padding-left: 0;
}

.page-item {
  width: 36px;
  text-align: center;
}

.page-item .page-link {
  padding: 0.5rem 0.75rem;
}

.page-item.disabled .page-link {
  cursor: not-allowed;
  opacity: 0.5;
}

@media (max-width: 768px) {
  .pagination-container {
    flex-direction: column;
    text-align: center;
  }

  .pagination {
    margin-bottom: 10px;
  }

  .page-item .page-link {
    padding: 0.4rem 0.5rem;
  }
}

@media (max-width: 576px) {
  .pagination {
    flex-wrap: nowrap;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .pagination-container {
    margin-bottom: 20px;
  }

  .page-item .page-link {
    padding: 0.3rem 0.4rem;
  }

  .page-item.disabled .page-link {
    visibility: visible;
    padding: 0.3rem 0.4rem;
  }
}
</style>
